import { useEffect, useState } from "react";
import { useMessengerConfiguration } from "V2.0/HomePages/Integrations/Messenger/useMessengerConfiguration";
import { useCommunicationBinding } from "./useCommunicationBinding";
import { PageIdBinding } from "./PageId/PageIdBinding";

function MessengerCommunicationBinding(props) {
  const {
    communicationBinding,
    syncAssistant,
    workspaceId,
    assistantId,
    assistantType,
    locked
  } = props;
  const { addCommunicationBinding, removeCommunicationBinding } =
    useCommunicationBinding({
      syncAssistant,
      assistantId,
      workspaceId,
      assistantType,
    });
  const [openDelete, setOpenDelete] = useState({
    item: null,
    isOpen: false,
  });
  const { messengerConfiguration } = useMessengerConfiguration(workspaceId);

  const handleBindingDelete = () => {
    removeCommunicationBinding(openDelete.item._id).then(() => {
      setOpenDelete({ item: null, isOpen: false });
    });
  };

  const handleBindingAdd = (data, closeDialog) => {
    const payload = {
      channelType: assistantType,
      isActive: true,
      ...data,
    };
    addCommunicationBinding(payload).then(closeDialog);
  };

  const pageIds = messengerConfiguration.data?.pageID
    ? [messengerConfiguration.data?.pageID]
    : [];

  return (
    <PageIdBinding
      isOpen={openDelete.isOpen}
      onClose={() => setOpenDelete({ isOpen: false, item: null })}
      onBindingDelete={(item) => setOpenDelete({ isOpen: true, item })}
      onBindingAdd={handleBindingAdd}
      onBindingConfirmDelete={handleBindingDelete}
      pageIds={pageIds}
      communicationBinding={communicationBinding}
      locked={locked}
    />
  );
}

export { MessengerCommunicationBinding };
